import { cva } from "class-variance-authority";

/**
 * The card-surface recipe, in its own module so `ColocaSurface.tsx` only exports a component and Fast Refresh
 * keeps working.
 *
 * Import this directly when the surface must be a non-`div` root — a `<section>` hero, an `<article>` card, a
 * `<button>` row — and `ColocaSurface` otherwise.
 */
export const colocaSurfaceVariants = cva("", {
  variants: {
    variant: {
      panel: "rounded-2xl border border-border bg-card shadow-sm",
      muted: "rounded-2xl border border-border bg-muted",
      plain: "rounded-2xl border border-border bg-card",
    },
    padding: {
      none: "",
      sm: "p-3",
      md: "p-4",
      lg: "p-5",
    },
    /**
     * Hover lift + focus ring for a surface the user can click. Pair it with an element that is actually
     * focusable — a `<button>` or an `<a>`; the styling alone does not make a `<div>` operable.
     */
    interactive: {
      true: "text-left transition-all hover:border-ring/40 hover:shadow-[var(--shadow-card)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
      false: "",
    },
  },
  defaultVariants: {
    variant: "panel",
    padding: "md",
    interactive: false,
  },
});
